<div class="release-karte" data-testid="release-karte">
  @switch (ladestatus()) {
    @case ('laedt') {
      <p class="release-karte__hinweis" role="status" aria-live="polite" data-testid="releases-laedt">
        {{ 'projectForm.releases.laedt' | translate }}
      </p>
    }
    @case ('fehler') {
      <div class="release-karte__fehler" role="alert" data-testid="releases-ladefehler">
        <span>{{ 'projectForm.releases.ladefehler' | translate }}</span>
        <button mat-stroked-button type="button" data-testid="releases-erneut" (click)="laden()">
          {{ 'projectForm.releases.erneutVersuchen' | translate }}
        </button>
      </div>
    }
    @default {
      @if (releases().length) {
        <ul class="release-karte__liste">
          @for (r of releases(); track r.id) {
            <li class="release-karte__zeile" data-testid="release-zeile">
              <span class="release-karte__id" [title]="r.id" data-testid="release-id-zelle">{{ r.id }}</span>
              <span class="release-karte__name" [title]="r.label" data-testid="release-name-zelle">{{ r.label }}</span>
              <span class="release-karte__stichtag" data-testid="release-stichtag-zelle">{{ stichtag(r) }}</span>
              <app-status-pill
                size="sm"
                [kind]="pillenArt(r)"
                [label]="'testResults.freigabe.status.' + r.status | translate"
              />
              <button
                mat-button
                type="button"
                class="release-karte__bearbeiten"
                data-testid="release-bearbeiten"
                [attr.aria-label]="'projectForm.releases.bearbeitenAria' | translate: { id: r.id }"
                (click)="bearbeiten(r)"
              >
                {{ 'projectForm.releases.bearbeiten' | translate }}
              </button>
            </li>
          }
        </ul>
      } @else {
        <p class="release-karte__hinweis" data-testid="releases-leer">
          {{ 'projectForm.releases.leer' | translate }}
        </p>
      }
      <button
        type="button"
        class="release-karte__hinzufuegen"
        data-testid="release-hinzufuegen"
        (click)="hinzufuegen()"
      >
        <mat-icon aria-hidden="true">add</mat-icon>
        {{ 'projectForm.releases.hinzufuegen' | translate }}
      </button>
    }
  }
</div>

<app-release-dialog
  [(visible)]="dialogOffen"
  [projectId]="projectId()"
  [release]="ausgewaehlt()"
  [vorhandeneIds]="vorhandeneIds()"
  (gespeichert)="laden()"
/>
